/**
 * Site header.
 *
 * The redesign header is a solid, sticky ink-blue bar on every page - it no
 * longer switches between a transparent overlay and a white blurred bar on
 * scroll, so the only job left here is to make sure server-rendered
 * "hidden until JS" attributes are cleared.
 */
(function (Drupal) {
  Drupal.behaviors.kStickyHeader = {
    attach(context) {
      const header = context.querySelector?.("[data-sticky-header]");
      if (!header) return;
      if (header.dataset.kStickyInit === "1") return;
      header.dataset.kStickyInit = "1";

      header.classList.remove(
        "-translate-y-full",
        "opacity-0",
        "pointer-events-none"
      );
      header.removeAttribute("aria-hidden");
    },
  };
})(Drupal);
